import { Flex } from "@shared/primitive-components"
import { Logo } from "../Branding"
import { logoWrapper } from "./styles/authStyles"

export const LogoBlock = () => (
  <Flex css={logoWrapper}>
    <Logo height={80} />
  </Flex>
)
